import React from 'react';
import {Link} from 'react-router-dom'
import {IconNotFound} from "./../assets/images/icons";
import "./NotFound.scss";

export default function NotFound() {
  return (
    <div className="not-found">
      <div className="page-not-found-content container">
        <img className="not-found-icon" src={IconNotFound} alt="astronomy icon"/>
        <h2 className="montserrat">You’ve reached the edge of Spaced!</h2>
        <p className="not-found-text">The page you’re looking for was not found.</p>
        <Link to="/"><button className="page-not-found-button"><div>Travel Back</div></button></Link>
      </div>
      <a href={`${process.env.REACT_APP_INVESTOR_APP_URL}/login`}>
        <button className="page-not-found-button login-button">
          <div>Login</div>
        </button>
      </a>
    </div>
  );
}
